module.exports = __webpack_public_path__ + "fonts/Calibre-BoldItalic.73bcd509.woff";